import { draftTrip } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getDraftTripList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(draftTrip.draftTripBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getDraftTripStats(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftTrip.draftTripBase}stats/`, { params })
        // return the raw payload ({ results, totals }) - handleResponse would
        // mangle it because it has a "results" key.
        .then((res) => resolve(res.data))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportDraftTripStats(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftTrip.draftTripBase}stats_export/`, {
          params,
          responseType: "blob",
        })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  getDraftTripObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftTrip.draftTripBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  updateDraftTripTrailer(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${draftTrip.draftTripBase}${id}/update_trailer/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  deleteDraftTrip(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${draftTrip.draftTripBase}${id}/delete_trip/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportToExcel(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftTrip.draftTripBase}export/`, { params, responseType: "blob" })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
});
